import React, { useEffect, useState } from 'react';
import { Outlet, Link, Navigate, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useBookContext } from "../contexts/bookContext";
import {
    BottomNavigation, BottomNavigationAction, Paper,
     AppBar,
    Toolbar, 
    IconButton,
    Typography,
    Button,
    Container,
    Tabs,
    Tab,
    Box,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
 

import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LogoutIcon from '@mui/icons-material/Logout';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MenuIcon from '@mui/icons-material/Menu';
import HandymanIcon from '@mui/icons-material/Handyman';

import dayjs from 'dayjs';
import 'dayjs/locale/ko';

import axios from "axios";



function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const MainLayout = () => {
    let navigate = useNavigate();
    const { userData, isLogin, setLogOut, updateUserInfo, actions } = useBookContext();
    const [value, setValue] = useState('/home');
    const [init, setInit] = useState(true);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    let paramUserEmail = searchParams.get('userEmail') || undefined;
    let paramUserPw = searchParams.get('userPw') || undefined;
    const paramNoTab = searchParams.get('notab') || "no";
    const queryList = [...searchParams];

//    console.log("mainLayout paramUserEmail :" + paramUserEmail)
//    console.log("mainLayout paramUserPw :" + paramUserPw)


    useEffect(() => {
        if (!paramUserEmail || !paramUserPw) {
            console.log("mainLayOut useEffect checkLogin")
            checkLogin();
        }
    }, [userData]);



    useEffect(() => {
        if (paramUserEmail && paramUserPw) {
            login();
        }

    }, [init]);

    const checkLogin = () => {
        console.log("mainLayout checkLogin userData : " + JSON.stringify(userData))

        if (!isLogin()) {
            console.log("mainLayOut 로그인상태아님")
            navigate('/login');
        }            

    }



    const login = async () => {

        try {

            const reqData = {};
            reqData.userEmail = paramUserEmail;
            reqData.userPW = paramUserPw;


            let response = await axios.post("/api/booking/CheckUser", reqData);
            console.log("login result :" + JSON.stringify(response.data))
            if ((response.data.code === 0)) {
                let userInfo = response.data.result;
                var newData = {}
                newData.userEmail = userInfo.userEmail;
                newData.userPhone = userInfo.userPhone;
                newData.userName = userInfo.userName;
                newData.chargeMoney = userInfo.chargeMoney;
                newData.chargeCount = userInfo.chargeCount;
                newData.bonusCount = userInfo.bonusCount;
                newData.userLevel = userInfo.userLevel;
                newData.unlimitUser = userInfo.unlimitUser;

                updateUserInfo(newData);
//                console.log("mainLayout save new userdata")
                //                checkLogin();


            } else {
                console.log("login error checklogin")
                var newData = {}
                updateUserInfo(newData);
                navigate('/login');
            }
        } catch (err) {
            console.error(err);
            logOut();
        }

    }



    const logOut = () => {
        paramUserEmail = undefined;
        paramUserPw = undefined;
        setLogOut();
        checkLogin();
    }

    const handleChange = (event, newValue) => {
//        console.log("tab goto :"+newValue)
        setValue(newValue);
        if (newValue == 'logout') {
            paramUserEmail = undefined;
            paramUserPw = undefined;
            setLogOut();
            navigate('/login');
        } else {
            navigate(newValue)
        }
    };


    const renderMiddleUserMenu = (  ) => {
        if (!userData || !userData.userLevel) {
            return null;
        }

        if (userData.userLevel < 50) {
            return null;
        }

        if (isMobile) {
            return (
                <Tab label="유저추가" {...a11yProps(1)} icon={<PersonAddIcon />} to='/enrolluser' value='enrolluser' />

            )
/*
            return (
                <BottomNavigationAction label="유저추가" icon={<PersonAddIcon />} to='enrolluser' value='enrolluser' />
            )
 */          
        } else {
            return (
                <Tab label="유저추가" {...a11yProps(1)} icon={<PersonAddIcon />} to='/enrolluser' value='enrolluser' />

            )
        }
        

    }

    const renderAdminUserMenu = () => {
        if (!userData || !userData.userLevel) {
            return null;
        }

        if (userData.userLevel < 50) {
            return null;
        }



        if (isMobile) {
            return (
                <Tab label="관리자" {...a11yProps(1)} icon={<HandymanIcon />} to='adminPage' value='adminPage' />

            )
/*
            return (
                <BottomNavigationAction label="관리자" icon={<HandymanIcon />} to='adminPage' value='adminPage' />
            )
*/
        } else {
            return (
                <Tab label="관리자" {...a11yProps(1)} icon={<HandymanIcon />} to='adminPage' value='adminPage' />

            )
        }


    }


    const renderAddCourse = () => {

//        console.log("renderAddCourse :"+JSON.stringify(userData))
        if (!userData ) {
            return null;
        }
        if (!userData.chargeMoney && userData.chargeMoney < 1 && userData.bonusCount < 1 && userData.unlimitUser < 1) {
            return null;
        }

//        console.log("renderAddCourse 222:" + JSON.stringify(userData))


        if (isMobile) { 
            return (
                <Tab label="코스선택" {...a11yProps(1)} icon={<LocationOnIcon />} to='/enrollcourse' value='enrollcourse' />
            )
/*
            return (
                <BottomNavigationAction label="코스선택" icon={<LocationOnIcon />} to='enrollcourse' value='enrollcourse' />
            )
*/
        } else {
            return (
                <Tab label="코스선택" {...a11yProps(1)} icon={<LocationOnIcon />} to='/enrollcourse' value='enrollcourse' />
            )

        }
    }

    const mobileLayout = (
        <>
            <Outlet />
            <Paper
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1000, // Ensures the navigation stays on top of other content
                }}
                elevation={3}
            >
                <BottomNavigation
                    value={value}
                    onChange={handleChange}
                    showLabels // Always show labels for better usability
                >
                    <BottomNavigationAction label="홈" icon={<HomeIcon />} to='/home' value='/home' />
                    {renderAddCourse()}
                    {renderMiddleUserMenu()}
                    {renderAdminUserMenu()}
                    <BottomNavigationAction label="내정보" icon={<PersonIcon />} to='/myinfo' value='myinfo' />
                    <BottomNavigationAction label="로그아웃" icon={<LogoutIcon />} value='logout' />
                </BottomNavigation>
            </Paper>


        </>
            
    )

    const mobileLayoutNoTab = (
        <>
            <Outlet />
        </>

    )


    const mobileLayoutNew = (
        <>
            <Outlet />
            <Box sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1000, // Ensures the navigation stays on top of other content
                bgcolor: 'background.paper'
            }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
                    textColor="inherit"
                    variant="scrollable"
                    scrollButtons="auto" // Shows scroll buttons when needed
                    allowScrollButtonsMobile
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="홈" {...a11yProps(0)} icon={<HomeIcon />} to='/home' value='/home' />
                    {renderAddCourse()}
                    {renderMiddleUserMenu()}
                    {renderAdminUserMenu()}

                    <Tab label="내정보" {...a11yProps(1)} icon={<PersonIcon />} to='/myinfo' value='myinfo' />
                    <Tab label="로그아웃" {...a11yProps(2)} icon={<LogoutIcon />} value='logout' />
                </Tabs>
            </Box>


        </>

    )



    const deskTopLayOut = (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Container maxWidth="md">
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
                        textColor="inherit"
                        variant="fullWidth"
                    >
                        <Tab label="홈" {...a11yProps(0)} icon={<HomeIcon />} to='/home' value='/home' />
                        {renderAddCourse()}
                        {renderMiddleUserMenu()}
                        {renderAdminUserMenu()}

                        <Tab label="내정보" {...a11yProps(1)} icon={<PersonIcon />} to='/myinfo' value='myinfo' />
                        <Tab label="로그아웃" {...a11yProps(2)} icon={<LogoutIcon />} value='logout' />
                    </Tabs>
                </Container>
            </Box>
            <Outlet />


        </>

    )





    if (isMobile) {
        if (paramNoTab == 'yes') {
//            console.log("notab")
            return mobileLayoutNoTab;
        } else {
//            return mobileLayout;
            return mobileLayoutNew;
        }
    } else {
        return deskTopLayOut;
    }
}

export default MainLayout;